import React, { useEffect, useRef } from 'react';
import './AdSenseAd.css';

const AdSenseAd = ({ 
  client = 'ca-pub-8036975838416728',
  slot = '2682400742',
  style = { display: 'block' },
  format = 'auto',
  responsive = 'true',
  className = '',
  position = 'default'
}) => {
  const adRef = useRef(null);

  useEffect(() => {
    const initializeAd = () => {
      try {
        // AdSenseスクリプトが読み込まれているかチェック
        if (typeof window !== 'undefined' && window.adsbygoogle && adRef.current) {
          const insElement = adRef.current.querySelector('.adsbygoogle');
          if (insElement && !insElement.hasAttribute('data-adsbygoogle-status')) {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          }
        }
      } catch (error) {
        console.warn('AdSense initialization error:', error);
      }
    };

    // AdSenseスクリプトがまだ読み込まれていない場合は待機
    if (window.adsenseLoaded) {
      initializeAd();
    } else if (!window.adsenseError) {
      const checkAdSense = setInterval(() => {
        if (window.adsenseLoaded || window.adsbygoogle) {
          clearInterval(checkAdSense);
          initializeAd();
        }
      }, 100);
      
      // 5秒後にタイムアウト
      setTimeout(() => clearInterval(checkAdSense), 5000);
    }
  }, []);

  return (
    <div className={`adsense-container adsense-${position} ${className}`}>
      <div className="adsense-label">広告</div>
      <div ref={adRef}>
        <ins
          className="adsbygoogle"
          style={style}
          data-ad-client={client}
          data-ad-slot={slot}
          data-ad-format={format}
          data-full-width-responsive={responsive}
        />
      </div>
    </div>
  );
};

// レスポンシブバナー広告（推奨）
export const ResponsiveBannerAd = ({ position = 'default' }) => (
  <AdSenseAd
    position={position}
    style={{ display: 'block' }}
    format="auto"
    responsive="true"
  />
);

// 大型バナー広告
export const LargeBannerAd = ({ position = 'default' }) => (
  <AdSenseAd
    position={position}
    style={{ display: 'inline-block', width: '728px', height: '90px' }}
    format=""
    responsive="false"
  />
);

// スクエア広告
export const SquareAd = ({ position = 'default' }) => (
  <AdSenseAd
    position={position}
    style={{ display: 'inline-block', width: '250px', height: '250px' }}
    format=""
    responsive="false"
  />
);

export default AdSenseAd;